// @flow

import gql from 'graphql-tag';

const upcomingAppRequestFormQuery = gql`
  query upcomingAppRequestFormQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      image
      name
      isUpcoming
    }
  }
`;

export default upcomingAppRequestFormQuery;
